import { FeedMedia } from "@/types/feed-media";
import { FollowersData } from "@/types/followers";
import { StoryContainer } from "@/types/stories";

export interface ProfileData {
  id: string;
  username: string;
  full_name: string;
  biography: string;
  profile_pic_url: string;
  is_private: boolean;
  followersCount: number;
  followingCount: number;
  postsCount: number;

  chaining_results?: ChainingResult[];
  fake_chaining_results?: boolean;
}

export interface ChainingResult {
  profile_pic_url: string;
  full_name: string;
  username: string;
}

export interface FollowersAndStories {
  data: FollowersData;
  stories: StoryContainer;
}

export interface ProfileComplete {
  profileData: ProfileData;
  feedMedia: FeedMedia;
  followersAndStories: FollowersAndStories;
  searchedAt: number;
  searchType: string;
}

export interface WebProfileData {
  username: string;
  full_name: string;
  biography: string;
  profile_pic_url: string;
  is_private: boolean;
  followersCount: number;
  followingCount: number;
}

const API_BASE_URL = "https://api.teagram.app/api";

export const api = {
  fetchWebProfileData: async (username: string): Promise<WebProfileData> => {
    const response = await fetch(
      `${API_BASE_URL}/web_profile_data/${username}`,
      {
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
          "X-Delivery": "ok",
        },
      },
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch web profile data: ${response.status}`);
    }

    return response.json();
  },

  fetchProfileData: async (username: string): Promise<ProfileData> => {
    const response = await fetch(`${API_BASE_URL}/profile_data/${username}`, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
        "X-Delivery": "ok",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch profile data: ${response.status}`);
    }

    return response.json();
  },

  fetchFeedMedia: async (username: string): Promise<FeedMedia> => {
    const response = await fetch(`${API_BASE_URL}/feed_media/${username}`, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
        "X-Delivery": "ok",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch feed media: ${response.status}`);
    }

    return response.json();
  },

  fetchFollowersAndStories: async (
    username: string,
  ): Promise<FollowersAndStories> => {
    const response = await fetch(
      `${API_BASE_URL}/followers_and_stories/${username}`,
      {
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
          "X-Delivery": "ok",
        },
      },
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch followers and stories: ${response.status}`,
      );
    }

    return response.json();
  },
};
